export default {
    // 本地存储
    set(key, value) {
      window.localStorage.setItem(key, value)
    },
    get(key) {
      return window.localStorage.getItem(key)
    },
    cls() {
      window.localStorage.clear()
    },
    // 会话存储
    setSto(key,value){
      window.sessionStorage.setItem(key,value)
    },
    getSto(){
      window.sessionStorage.getItem(key)
    },
    clsSto(){
        window.sessionStorage.clear()
    }
  }
  